import s from './ModelButtonToggle.module.scss'

import { AnimatePresence, motion } from 'framer-motion'
import { ChangeEvent, useEffect, useState } from 'react'
import { Object3D } from 'three'
import * as TWEEN from '@tweenjs/tween.js'

import { animateChangeMeshes, TweenEasing } from '../../utils/animate-change-meshes'

interface ModelButtonToggleProps {
  model: Object3D | undefined
}

export const ModelButtonToggle = ({ model }: ModelButtonToggleProps): JSX.Element => {
  const [hdMode, setHdMode] = useState(false)

  let realMeshes: Array<Object3D> = []
  let voxelMeshes: Array<Object3D> = []
  if (model) {
    for (const mesh of model.children[0].children) {
      if (mesh.name.includes('real-')) {
        realMeshes = mesh.children
      }

      if (mesh.name.includes('voxel-')) {
        voxelMeshes = mesh.children
      }
    }
  }

  const handleChangeToggle = (event: ChangeEvent<HTMLInputElement>) => {
    setHdMode(event.target.checked)
  }

  const tweenEasing: TweenEasing = 'Quartic'
  const minOpacity = 0.05
  useEffect(() => {
    if (!model) return

    const prevMeshes: Array<Object3D> = hdMode ? realMeshes : voxelMeshes
    const currentMeshes: Array<Object3D> = !hdMode ? realMeshes : voxelMeshes

    currentMeshes.forEach((mesh) => {
      mesh.visible = false
    })

    TWEEN.removeAll()
    animateChangeMeshes(prevMeshes, 0, 'in', tweenEasing, minOpacity)
  }, [hdMode])

  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className={s.ModelButtonToggle}
      >
        <span className={s.caption}>{'HD mode'}</span>
        <label className={s.button_toggle}>
          <input className={s.input} type="checkbox" onChange={handleChangeToggle} />
          <span className={s.slider}></span>
        </label>
      </motion.div>
    </AnimatePresence>
  )
}
